import { HomeownersLegalPage } from "@/pages/HomeownersLegal/HomeownersLegal.page";

export default HomeownersLegalPage;
